import {dsColorNew} from "@palette";

export const MaximalLayoutNavMiniItemStyles = (isActive, isSubItem, theme) => ({
    flexDirection: 'column',
    textTransform: 'capitalize',
    padding: theme.spacing(1, 0, 0.5, 0),
    color: 'rgba(255,255,255,0.82)',
    borderRadius: theme.shape.borderRadius * 0.2,
    '&:hover': {
        backgroundColor: 'rgba(255,255,255,0.06)',
        color: 'rgba(255,255,255,0.85)',
    },
    ...( isSubItem && {
        padding: theme.spacing(1)
    } ),
    ...( isActive && {
        color: '#fff',
        backgroundColor: dsColorNew.appBlue,
        '&:hover': {
            color: '#fff',
            backgroundColor: dsColorNew.appBlueHover,
        },
        i: {
            color: '#fff'
        }
    })
})

export const MaximalLayoutNavMiniIconStyles = ({
    marginRight: 0,
    marginBottom: "4px",
    width: "22px",
    height: "22px",
    minWidth: 'auto',
    color: 'inherit'
})

export const MaximalLayoutNavMiniArrow = ({
    fontSize: 10,
    position: 'absolute',
    right: "4px",
    top: "11px"
})